const handleLoadEnd = () => {
    const loadingMessage = document.querySelector("form#reservation-form div.loading-message");
    if (loadingMessage) {
        loadingMessage.remove();
    }
};
export default handleLoadEnd;
